import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';
import { API_URL } from '@/config';

export const logoutUser = async (): Promise<any> => {
  const access_token = storage.getToken();

  if (!access_token) {
    return;
  }

  try {
    const response = await axios.post(`${API_URL}/v2/auth/logout`);
    return response;
  } catch (error) {
    // console.error('Error env variable', error);
    // throw error;
  }
};

export const useLogoutUser = (config = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation<any, Error>({
    mutationFn: logoutUser,
    onError: (error) => {
      addNotification({
        type: 'error',
        title: 'Failed to logout',
        message: error.message,
      });
    },
    onSuccess: (data) => {
      if (data) {
        addNotification({
          type: 'success',
          title: 'Logged out successfully',
        });
      }
    },
    ...config,
  });
};
